import * as React from 'react'
import type { Language } from 'codegen/types'
import { useTranslation } from 'react-i18next'
import { toStudioIntlLocale } from '@repo/studio-i18n-translations/load-translation'

export function useReloadLanguage() {
  const { i18n } = useTranslation()

  return React.useCallback(
    async (language: Language) => {
      await i18n.changeLanguage(toStudioIntlLocale(language) ?? language)
      await i18n.reloadResources()
      i18n.emit('languageChanged')
    },
    [i18n],
  )
}
